import { Box, Button, Text } from '@/components'
import { useTranslations } from '@/core/translation'
import { errorBoundaryStyles as styles } from './ErrorBoundary.style'

/** Default fallback shown by {@link ErrorBoundary} when a descendant throws. */
export default function ErrorFallback() {
  const t = useTranslations('errorBoundary')

  const onReload = () => window.location.reload()

  return (
    <Box sx={styles.root}>
      <Box sx={styles.content}>
        <Text variant="displayXsSemibold" sx={styles.title}>
          {t('title')}
        </Text>
        <Text variant="textMd" sx={styles.message}>
          {t('message')}
        </Text>
        <Button onClick={onReload}>{t('reload')}</Button>
      </Box>
    </Box>
  )
}
